import React from "react";
import RegistrationForm from "../RegistrationForm";
import FakePaypalButton from "./PaypalButton";
import FakeStripePaymentElement from "./StripePaymentElement";

export default function (props) {
  return (
    // This is required so that the payment error styles work
    <div id="registration-form">
      <RegistrationForm
        {...props}
        PaypalButton={FakePaypalButton}
        StripePaymentElement={FakeStripePaymentElement}
      />
    </div>
  );
}
